// extracted by mini-css-extract-plugin
export default {"container":"style_container__iScZF","body":"style_body__vAm5j"};